<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 d-flex pt-2">
        <div class="pr-1">
          <span [innerHTML]="labelHtml | placeholderHighlight"></span>
          <br />
          <div *ngIf="(!moreInfo && isActiveStatus) || !isActiveStatus">
            <span *ngIf="schedule; else noSchedule">
              <mat-label>Last Completed Date:</mat-label>
              <b class="date date-neutral"
                >&nbsp;<mat-label
                  [innerHTML]="dateValue1 | date: 'M/d/yyyy'"
                ></mat-label
                ></b
              >,&nbsp;
              <mat-label>Next Inspection Due Date:</mat-label>
              <b
                class="date"
                [ngClass]="{ 'expired-date': nextDueExpired && isActiveStatus }"
                >&nbsp;<mat-label
                  [innerHTML]="dateValue2 | date: 'M/d/yyyy'"
                ></mat-label
                ></b
              ><b *ngIf="inGracePeriod && isActiveStatus" class="grace-note"
                >&nbsp;(Within grace period)</b
              ><span *ngIf="approvedExtendedDate">,&nbsp;</span>
              <span *ngIf="approvedExtendedDate">
                <mat-label>Extended Date:</mat-label>
                <b
                  class="date"
                  [ngClass]="{ 'expired-date': extendedDateExpired && isActiveStatus }"
                  >&nbsp;<mat-label
                    [innerHTML]="approvedExtendedDate | date: 'M/d/yyyy'"
                  ></mat-label
                ></b>
              </span>
            </span>
            <ng-template #noSchedule>
              <b *ngIf="isActiveStatus" class="red">Schedule Not Found!</b>
            </ng-template>
          </div>
          <div *ngIf="moreInfo && isActiveStatus" class="pr-1 bold color-red">
            <b class="red">{{ moreInfo }}</b>
          </div>
        </div>
      </div>

      <div class="col-2 d-flex flex-row justify-content-end align-items-center suggestion-anchor">
        <mat-checkbox-with-roles
          labelPosition="before"
          [checked]="checked"
          [disabled]="disabled"
          (change)="checkboxChanged($event)"
          color="primary"
          [roleCodes]="roleCodes"
          [user]="user"
          [warning]="moreInfo ?? ''"
          [date]="date"
        >
        </mat-checkbox-with-roles>
        <mat-icon
          *ngIf="suggested && !checked && !disabled"
          class="suggestion-icon"
          [matTooltip]="suggestionReason || 'ASCC recommends reviewing and signing this task manually.'"
          matTooltipPosition="above"
          >lightbulb</mat-icon
        >
      </div>
    </div>
  </div>
</div>
